import { DropdownMenuItem, DropdownMenuLabel } from '@/components/ui/dropdown-menu';
import { ShieldHalfIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useGetUserApi } from '@liquidbudget/common';

interface Props {
  pathname: string;
}

export function BudgetSwitcherAdmin({ pathname }: Props) {
  const { data: user } = useGetUserApi();
  const isAdmin = user?.role === 'ADMIN';

  if (!isAdmin) {
    return null;
  }

  return (
    <>
      <DropdownMenuLabel className="text-xs text-muted-foreground">Administration</DropdownMenuLabel>
      <DropdownMenuItem asChild disabled={pathname === '/admin/users'}>
        <Link to="/admin/users" className="flex items-center gap-2">
          <div className="flex size-6 items-center justify-center">
            <ShieldHalfIcon className="size-4 shrink-0" />
          </div>
          Users
        </Link>
      </DropdownMenuItem>
      <DropdownMenuItem asChild disabled={pathname === '/admin/subscriptions'}>
        <Link to="/admin/subscriptions" className="flex items-center gap-2">
          <div className="flex size-6 items-center justify-center">
            <ShieldHalfIcon className="size-4 shrink-0" />
          </div>
          Subscriptions
        </Link>
      </DropdownMenuItem>
    </>
  );
}
